<div class="jbm-modal" [ngClass]="className" style="z-index:{{modalZIndex}}">
   <ng-container *ngTemplateOutlet="template; context: { 'modal': ModalService}"></ng-container>
</div>
<div class="jbm-modal-backdrop" style="z-index:{{(modalZIndex-1)}}"></div>